import {DefaultDeviceCatalogContent} from "./default-device-catalog-content";
import {DefaultDeviceCategory} from "./default-device-category";
import {DefaultAssetRepresentation} from "./default-asset-representation";

export class DefaultDeviceCatalog {
  uuid?: string;
  name: string;
  description: string;
  version: string;
  active: boolean;
  defaultDeviceCategory: DefaultDeviceCategory;
  defaultAssetRepresentation: DefaultAssetRepresentation;
  content: DefaultDeviceCatalogContent;
  creationDate: number;
  updatedDate: number;
}
